// extracted by mini-css-extract-plugin
export default {"item":"ServiceCard_item__VLkPL","item__cover":"ServiceCard_item__cover__0PAKE","item__cover--img":"ServiceCard_item__cover--img__3V4Y6","item__text":"ServiceCard_item__text__zkcD2"};